var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1722915073317,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2156,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M866.304 85.504H157.696c-68.096 0-123.392 55.296-123.392 123.392v608.256c0 68.096 55.296 123.392 123.392 123.392h708.608c68.096 0 123.392-55.296 123.392-123.392V208.896c0-68.096-55.296-123.392-123.392-123.392z m55.296 527.36h-275.456c-55.296 0-100.352-45.056-100.352-100.352s45.056-100.352 100.352-100.352H921.6v200.704z m0 204.288c0 30.208-24.576 55.296-55.296 55.296H157.696c-30.208 0-55.296-24.576-55.296-55.296V208.896c0-30.72 24.576-55.296 55.296-55.296h708.608c30.208 0 55.296 24.576 55.296 55.296v135.68h-275.456c-92.672 0-168.448 75.776-168.448 168.448s75.776 168.448 168.448 168.448H921.6v135.68z m-251.392-304.128c0-24.576 19.968-44.544 44.544-44.544 24.576 0 44.544 19.968 44.544 44.544 0 24.576-19.968 44.544-44.544 44.544-24.576-0.512-44.544-19.968-44.544-44.544z",
    "p-id": 2157,
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAccounts);
export default __webpack_public_path__ + "static/media/nav-accounts.0eb52b78aa4b010f3e0e77a3cbe3c381.svg";
export { ForwardRef as ReactComponent };